import { InjectionToken } from '@angular/core';

export type HeroCustomer = {
 alias: string;
 name: string;
};

export const HERO_CUSTOMER = new InjectionToken<HeroCustomer>('HERO applications');

